import { createIcon } from "@chakra-ui/react";

export const BookClosedUser = createIcon({
  displayName: "BookClosedUser",
  viewBox: "0 0 24 24",
  d: "M5.125 0A4.125 4.125 0 0 0 1 4.125v15.75h.019A3.749 3.749 0 0 0 4.75 24h16.125c.623 0 1.125-.502 1.125-1.125s-.502-1.125-1.125-1.125H20.5v-3.253a2.629 2.629 0 0 0 1.5-2.372v-13.5A2.627 2.627 0 0 0 19.375 0H5.125zM18.25 18.75v3H4.75c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h13.5zM4.75 16.5a3.72 3.72 0 0 0-1.5.314V4.125c0-1.036.84-1.875 1.875-1.875h14.25c.206 0 .375.169.375.375v13.5a.376.376 0 0 1-.375.375H17.5v-.75A3.749 3.749 0 0 0 13.75 12h-3A3.749 3.749 0 0 0 7 15.75v.75H4.75zm7.5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
  defaultProps: {
    "aria-label": "A book, closed, with a human shape on the cover"
  }
});

export default BookClosedUser;
